(function () {
    'use strict';
    angular
            .module('imnApp')
            .factory('ModalConstructor', ModalConstructor);

    ModalConstructor.$inject = ['$uibModal', '$uibModalStack', 'RequestService'];

    function ModalConstructor($uibModal, $uibModalStack, RequestService) {

        return {
            open: open,
            isOpen: isOpen,
            closeAll: closeAll
        };

        function open(modal) {
            if (modal) {
                var modalInstance = $uibModal.open(modal);
                if (!modal.avoidCancel) {
                    modalInstance.closed.then(function () {
                        RequestService.cancelRequests('/api/')
                    });
                }
                return modalInstance;
            } else {
                throw 'parameter modal cannot be undefined!';
            }
        }

        function isOpen() {
            return !!$uibModalStack.getTop();
        }

        function closeAll() {
            if (isOpen) {
                $uibModalStack.dismissAll();
            }
        }

    }
})();
